<template>
  <el-dialog :title="title" :visible.sync="dialogVisible" width="600px" :before-close="handleClose">
    <h4>{{ this.$t('BusinessPurchaseApplyDetail.reviewResult') }}</h4>
      <el-radio-group v-model="form.auditResult" :disabled="form.disabled">
        <el-radio label="1">{{ this.$t('BusinessPurchaseApplyDetail.reviewResult2') }}</el-radio>
        <el-radio label="2">{{ this.$t('BusinessPurchaseApplyDetail.reviewResult1') }}</el-radio>
      </el-radio-group>
    <h4>{{ this.$t('BusinessPurchaseApplyDetail.reviewRemark') }}</h4>
    <div class="relative">
      <BjUpload v-show="false" ref="BjUpload" class="avatar-uploader" auto-upload
      @afterUpload="afterUpload"></BjUpload>
      <quill-editor ref="myQuillEditor" v-model="form.remark" :disabled="form.disabled" :options="editorOption" :placeholder="$t('BusinessPurchaseApplyDetail.wordLimitText')" class="quillHeight"
      @change="onEditorChange($event)"></quill-editor>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('cancelText') }}</el-button>
      <el-button type="primary" @click="confirm">{{ $t('okText') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import editorMixins from '@/utils/editorMixins';
import BjUpload from '@/components/BjUpload/index';

export default {
  components: {
    BjUpload
  },
  mixins: [editorMixins],
  props: {
    // eslint-disable-next-line vue/require-default-prop
    auditStatus: {
      require: true,
      type: String
    },
  },
  data() {
    return {
      dialogVisible: false,
      title: this.$t('approvedText'),
      form: {
        auditResult: null,
        remark: null,
        disabled: false
      }
    };
  },
  methods: {
    handleClose(done) {
      this.hide();
    },
    show(title) {
      this.title = title;
      this.form.auditResult = null;
      this.form.remark = null;
      this.form.disabled = false;
      this.dialogVisible = true;
    },
    hide() {
      this.dialogVisible = false;
    },
    confirm() {
      this.$confirm(this.$t('InternalSalesOrderDetails.want'))
        .then(_ => {
          if (!this.form.auditResult) return this.$message.error(this.$t('BusinessPurchaseApplyDetail.errorMsg1'));
          let data = {};
          if (this.auditStatus === '1') {
             data = {
              remark: this.form.remark,
              auditResult: this.form.auditResult === '1' ? '1' : '2',
            };
          } else if (this.auditStatus === '2') {
            data = {
              remark2: this.form.remark,
              auditResult: this.form.auditResult === '1' ? '3' : '4',
            };
          } else {
            data = {
              remark3: this.form.remark,
              auditResult: this.form.auditResult === '1' ? '5' : '6',
            };
          }
          this.$emit('confirm', data);
          this.hide();
        })
        .catch(_ => {});
    },
  },
};
</script>

<style></style>
